// extracted by mini-css-extract-plugin
module.exports = {"container":"cover-tab_container__tsZKT","active":"cover-tab_active__8ti39"};